// Papéis do OPERADOR (crachá) — espelho FRONT do módulo puro do backend
// (backend_v2/src/modules/warehouse/operatorRoles.js). Mesma regra, para o
// terminal mostrar só o que o crachá identificado pode fazer. Sem IO.
//
// Pedido do dono (25/08): picking/packing/fabrica/supervisor são do OPERADOR,
// não do login. "supervisor" faz TUDO; os outros três são recortes do chão.

/** Os quatro papéis atribuíveis livremente por operador (ordem canônica). */
export const WMS_OPERATOR_ROLES = Object.freeze(['picking', 'packing', 'fabrica', 'supervisor']);

/** O papel guarda-chuva — faz tudo. */
export const SUPERVISOR_ROLE = 'supervisor';

/**
 * Ação do terminal → papel exigido. `supervisor` satisfaz qualquer uma. Ação
 * fora do mapa (ex.: consulta livre) não é gated: qualquer crachá válido faz.
 */
export const TERMINAL_ACTION_ROLE = Object.freeze({
    service_orders: 'picking',
    move: 'picking',
    intake: 'picking',
    repack: 'picking',
    shipping: 'packing',
    production: 'fabrica',
});

/** Lê os papéis do DTO tolerando null/legado; só papéis válidos, ordem canônica. */
export function NormalizeOperatorRoles(stored) {
    if (Array.isArray(stored)) {
        return WMS_OPERATOR_ROLES.filter((role) => stored.includes(role));
    }
    return [];
}

/**
 * O operador pode executar esta ação? `supervisor` faz tudo; senão precisa do
 * papel exato. Ação desconhecida é liberada (não gated por papel).
 */
export function OperatorCan(roles, action) {
    const normalized = NormalizeOperatorRoles(roles);
    if (normalized.includes(SUPERVISOR_ROLE)) {
        return true;
    }
    const required = TERMINAL_ACTION_ROLE[action];
    if (!required) {
        return true;
    }
    return normalized.includes(required);
}
